import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// Models
import { MetaData } from 'src/app/platform/models/utils';
import { ProductsData } from 'src/app/modules/products/models/products';

// Services
import { UiService } from 'src/app/platform/services/ui.service';
import { PlatformService } from 'src/app/platform/services/platform.service';
import { ProductsService } from 'src/app/modules/products/products.service';
import { ProceduresService } from 'src/app/modules/procedures/procedures.service';

@Component({
  selector: 'app-products-change',
  templateUrl: './products-change.component.html',
  styleUrls: ['./products-change.component.scss']
})
export class ProductsChangeComponent implements OnInit {
  public formData: FormGroup = new FormGroup({
    contract: new FormControl('', [Validators.required]),
    product: new FormControl('', [Validators.required]),
  });
  public contractsSelected: boolean = false;
  public contractsData: Array<ProductsData> = [];
  public productsData: Array<MetaData> = [];

  constructor(
    public dialog: MatDialogRef<ProductsChangeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      contract: ProductsData
    },
    private uiService: UiService,
    private platformService: PlatformService,
    private productService: ProductsService,
    private proceduresService: ProceduresService,
  ) { }

  ngOnInit(): void {
    if (this.data !== null && this.data.contract.id > 0){
      this.contractsSelected = true;
      this.formData.setValue({contract: this.data.contract, product: ''});

      this.onContractChange(this.data.contract);
    } else {
      this.uiService.showSpinner(true);

      this.productService.contractsGet().then((success) => {
        this.uiService.showSpinner(false);

        success.result.registers.forEach((contract: ProductsData) => {
          if (contract.isReplaceable) {
            this.contractsData.push(contract);
          }
        });
      }).catch((error) => {
        this.uiService.showSpinner(false);
        this.dialog.close();
        this.uiService.dialogShow('Ups!', 'No es posible realizar un cambio de plan en este momento. Estamos trabajando para solucionar el inconveniente.', 'alert');
      });
    }
  }

  onContractChange(contract: ProductsData): void {
    if (contract.product.id >= 1) {
      this.uiService.showSpinner(true);

      this.productService.productsReplaceableGet(contract.product.id).then((success) => {
        this.uiService.showSpinner(false);
        this.productsData = success.result;
      }).catch((error) => {
        this.uiService.showSpinner(false);
        this.dialog.close();
        this.uiService.dialogShow('Ups!', 'No es posible realizar un cambio de plan en este momento. Estamos trabajando para solucionar el inconveniente.');
      });
    } else {
      this.productsData = [];
    }
  }

  onCancel(): void {
    this.dialog.close();
  }

  onSubmit(): void {
    if (this.formData.valid) {
      this.uiService.showSpinner(true);

      this.productService.contractsChange(
        this.formData.get('contract')?.value.id,
        this.formData.get('product')?.value
      ).then((result) => {
        if (result.status) {
          this.dialog.close();

          this.uiService.showSpinner(false);
          this.uiService.dialogShow('Cambio solicitado', 'Tu pedido de cambio de plan fue enviado, a la brevedad un asistente revisará tu solicitud. Tu número de gestión es: <p><h1>' + result.result.id + '</h1>', 'success');

          this.proceduresService.proceduresUpdate(true);
        }
        else {
          this.uiService.showSpinner(false);
          this.uiService.dialogShow('Ups!', 'Hubo un inconveniente al intentar solicitar el cambio de plan. Por favor intenta nuevamente.', 'error');
        }
      }, (error) => {
        this.uiService.showSpinner(false);
        this.uiService.dialogShow('Ups!', 'No es posible realizar un cambio de plan en este momento. Estamos trabajando para solucionar el inconveniente.', 'alert');
      });
    } else {
      this.formData.markAllAsTouched();
      this.uiService.showSnackBar('Algunos datos no están completos');
    }
  }

  formHasError(formcontrol: string, data: string): any {
    const fields: any = {
      contract: {
        required:  'Seleccione un producto'
      },
      product: {
        required:  'Seleccione un plan comercial'
      }
    };

    return this.platformService.formHasError(this.formData, fields, formcontrol, data);
  }
}
